import React from 'react';
import cn from 'classnames';

import Translate from '@/assets/icons/translate.svg?react';
import LoaderCircle from '@/assets/icons/loader-circle.svg?react';
import { useLockFn } from 'ahooks';
import styles from './index.module.scss';
import { productTranslatePost } from '@/services/swagger/easourcing/SessionService';

/** 图标状态：normal-默认 | active-已翻译 | loading-加载中 */
type IconStatus = 'normal' | 'active' | 'loading';

type IconProps = {
  status?: IconStatus;
  resident?: boolean;
} & React.HTMLAttributes<HTMLSpanElement>;

export const Icon = (props: IconProps) => {
  const { status = 'normal', resident = false, ...rest } = props;
  const isLoading = status === 'loading';
  return (
    <span
      {...rest}
      className={cn(styles.icon, 'shrink-0', {
        [styles.normal]: status === 'normal',
        [styles.active]: status === 'active',
        [styles.loading]: isLoading,
        'inline-flex!': resident,
        'cursor-pointer': !isLoading,
      })}
    >
      {isLoading ? (
        <span className={styles.loaderIcon}>
          <LoaderCircle />
        </span>
      ) : (
        <Translate />
      )}
    </span>
  );
};

interface TextTranslateProps {
  text: string;
  inline?: boolean;
  className?: string;
  resident?: boolean;
  renderText: (text: string, icon: React.ReactNode) => React.ReactNode;
}
export const TextTranslate = ({
  text,
  inline = false,
  className,
  resident = false,
  renderText,
}: TextTranslateProps) => {
  const [newText, setNewText] = React.useState(text);
  const [isWrapHover, setIsWrapHover] = React.useState(true);
  const [iconStatus, setIconStatus] = React.useState<IconStatus>('normal');
  const handleTranslate = useLockFn(async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (iconStatus === 'loading') return;
    if (newText !== text) {
      setNewText(text);
      setIconStatus('normal');
      return;
    }
    setIconStatus('loading');
    try {
      const res = await productTranslatePost({
        product: text,
        language: ['English'],
      });
      setNewText(res?.data?.language?.[0]?.product || text);
      setIconStatus('active');
    } catch {
      setIconStatus('normal');
    }
  });

  const icon = <Icon status={iconStatus} resident={resident} onClick={handleTranslate} />;
  return (
    <div
      className={cn('inline-flex max-w-full items-center overflow-hidden gap-1 group', styles.iconWrap, className)}
      onMouseEnter={() => {
        if (!resident) setIsWrapHover(true);
      }}
      onMouseLeave={() => {
        if (!resident) setIsWrapHover(false);
      }}
    >
      {inline ? (
        renderText?.(newText, isWrapHover || iconStatus === 'loading' ? icon : null)
      ) : (
        <React.Fragment>
          {renderText?.(newText, isWrapHover || iconStatus === 'loading' ? icon : null)}
          {icon}
        </React.Fragment>
      )}
    </div>
  );
};
